import { createValidIcon } from '@ui/icons/utils/type-helper'

export const MarketDataClassificationIcon = createValidIcon((props) => {
  const { size, color } = props

  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 17 19'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M5.83301 12.5C6.29324 12.5 6.66602 12.8737 6.66602 13.334V17.5C6.66602 17.9602 6.29324 18.334 5.83301 18.334H0.833008C0.401671 18.334 0.0467642 18.006 0.00390625 17.5859L0 17.5V13.334C0 12.8737 0.372771 12.5 0.833008 12.5H5.83301ZM15.833 12.5C16.2932 12.5 16.666 12.8737 16.666 13.334V17.5C16.666 17.9602 16.2932 18.334 15.833 18.334H10.833C10.4017 18.334 10.0468 18.006 10.0039 17.5859L10 17.5V13.334C10 12.8737 10.3728 12.5 10.833 12.5H15.833ZM1.66602 16.667H5V14.167H1.66602V16.667ZM11.666 16.667H15V14.167H11.666V16.667ZM8.33301 6.66699C8.79314 6.66699 9.16584 7.03991 9.16602 7.5V8.33398H12.5C13.4202 8.33416 14.1658 9.07978 14.166 10V10.834C14.1658 11.2941 13.7931 11.667 13.333 11.667C12.8729 11.667 12.5002 11.2941 12.5 10.834V10H4.16602V10.834C4.16584 11.2941 3.79314 11.667 3.33301 11.667C2.87288 11.667 2.50018 11.2941 2.5 10.834V10C2.50018 9.07978 3.2458 8.33416 4.16602 8.33398H7.5V7.5C7.50018 7.03991 7.87288 6.66699 8.33301 6.66699ZM10.833 0C11.2932 1.44902e-07 11.666 0.373747 11.666 0.833984V5C11.666 5.46024 11.2932 5.83398 10.833 5.83398H5.83301C5.40167 5.83398 5.04676 5.50596 5.00391 5.08594L5 5V0.833984C5 0.373747 5.37277 0 5.83301 0H10.833ZM6.66602 4.16699H10V1.66699H6.66602V4.16699Z'
        fill={color}
      />
    </svg>
  )
})
